import { render, staticRenderFns } from "./TopCategory.vue?vue&type=template&id=e489405a&scoped=true&"
import script from "./TopCategory.vue?vue&type=script&lang=js&"
export * from "./TopCategory.vue?vue&type=script&lang=js&"
import style0 from "./TopCategory.vue?vue&type=style&index=0&id=e489405a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e489405a",
  null
  
)

export default component.exports